<div>
  @if (mandatory === true) {
    <div style="color: red">(*)</div>
  }
  <div>{{ caption }}</div>
</div>
<div>
  <dx-text-box [(value)]="value" [disabled]="isDisabled" mask="+38 (X00) 000-00-00" [maskRules]="rules">
    <dx-validator>
      @if (mandatory === true) {
        <dxi-validation-rule type="required" message="{{ 'FIELD_IS_REQUIRED' | translate }}"></dxi-validation-rule>
      }
    </dx-validator>
  </dx-text-box>
</div>
